/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.birthday_schedules.init());


App.birthday_schedules = {

  init() {
    if ($('.js-birthday-schedule-form').length) {
      $(document)
        .off('keyup', '.js-birthday-message-textarea', App.birthday_schedules.typed)
        .on('keyup', '.js-birthday-message-textarea', App.birthday_schedules.typed)

        .off('change', '.js-birthday-use-name', App.birthday_schedules.trigger_typed)
        .on('change', '.js-birthday-use-name', App.birthday_schedules.trigger_typed)

        .off('change', '.js-birthdays-active-checkbox', App.birthday_schedules.active_changed)
        .on('change', '.js-birthdays-active-checkbox', App.birthday_schedules.active_changed)

        .off('click', '.js-all-group-checkbox', App.birthday_schedules.all_group_changed)
        .on('click', '.js-all-group-checkbox', App.birthday_schedules.all_group_changed);

      this.trigger_typed();
      this.set_groups($('.js-all-group-checkbox')[0].checked);
      return $('.js-birthdays-active');
    }
  },


  active_changed(evt) {
    if (this.checked) {
      return $('.js-birthday-schedule-form .panel-body').addClass('active');
    } else {
      return $('.js-birthday-schedule-form .panel-body').removeClass('active');
    }
  },


  all_group_changed(evt) {
    return App.birthday_schedules.set_groups(this.checked);
  },


  set_groups(all_group_checked) {
    if (all_group_checked) {
      $('.js-birthday-groups').addClass('all-groups');
    } else {
      $('.js-birthday-groups').removeClass('all-groups');
    }

    return $('[data-all-group=false] input').prop('disabled', all_group_checked);
  },


  trigger_typed() {
    return $('.js-birthday-message-textarea').keyup();
  },


  typed(evt) {
    const $preview = $('.js-birthday-message-preview');
    const msg = $(this).val();
    const name = App.birthday_schedules.use_name() ? '{Contact name}, ' : '';
    return $preview.text(`${name}${msg}`);
  },

  use_name() {
    return $('.js-birthday-use-name').val() === '1';
  }
};
